import React, { useEffect } from "react";

//COMPONENTS
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import Button from "@/main/components/shared/button/button";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";

// STYLES/COMPONENTS LOCAL
import * as S from "./styles";

interface IModalVideoProps {
	isOpenModal: boolean;
	muteVideo?: boolean;
	refVideo: React.RefObject<HTMLVideoElement>;
	urlVideo: string;
	pauseVideo: () => void;
	setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
	closeModal: () => void;
	openModal: () => void;
}
function ModalVideo({ muteVideo = false, refVideo, urlVideo, pauseVideo, closeModal, openModal }: IModalVideoProps) {
	function handleClickClose(e: React.MouseEvent<HTMLButtonElement>) {
		e.preventDefault();
		e.stopPropagation();
		closeModal();
		pauseVideo();
	}

	function pictureInPictureOpen() {
		closeModal();
	}
	function pictureInPictureClose(this: HTMLVideoElement, _event: Event) {
		openModal();
	}

	useEffect(() => {
		if (!isNullUndefined(refVideo.current)) {
			refVideo.current.addEventListener("enterpictureinpicture", pictureInPictureOpen);
			refVideo.current.addEventListener("leavepictureinpicture", pictureInPictureClose);
		}

		return () => {
			if (!isNullUndefined(refVideo.current)) {
				refVideo.current.removeEventListener("enterpictureinpicture", pictureInPictureOpen);
				refVideo.current.removeEventListener("leavepictureinpicture", pictureInPictureClose);
			}
		};
	}, []);

	return (
		<S.Container>
			<video
				controls
				ref={refVideo}
				controlsList="nodownload"
				muted={muteVideo}
				src={urlVideo}
				style={{ width: "100%", height: "100%" }}
			>
				<track kind="captions" />
				Your browser does not support the video tag.
			</video>

			<S.AreaFooteButtons>
				<Button id="id-register-btn-close" type="button" onClick={handleClickClose}>
					{getTranslateByKey("information.close")}
				</Button>
			</S.AreaFooteButtons>
		</S.Container>
	);
}

function WrapperModalVideo(props: Omit<IModalVideoProps, "refVideo" | "pauseVideo">) {
	const refVideo = React.useRef<HTMLVideoElement>(null);

	function pauseVideo() {
		if (!isNullUndefined(refVideo.current)) {
			refVideo.current.pause();
		}
	}

	function customSetOpen(boolean: boolean) {
		props.setIsOpenModal(boolean);
		pauseVideo();
	}

	const customProps: IModalVideoProps = {
		...props,
		refVideo,
		pauseVideo,
	};

	return (
		<KogModalFadeComponent keepMounted open={props.isOpenModal} setOpen={customSetOpen}>
			<ModalVideo {...customProps} />
		</KogModalFadeComponent>
	);
}

export default WrapperModalVideo;
